import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <main>
      <div className="contained leading-22 tablet:mb-32 tablet:mx-auto mx-16 mb-24">
        <h1 className="text-32 leading-36 mb-32 mt-16 font-bold">Returns &amp; Order Help</h1>
        <h2 className="text-20 tablet:text-26 leading-20 tablet:leading-30 mb-16 font-medium">Start with your order details</h2>
        <p>
          If something is not right with your order, email us before sending an
          item back. Include your order number, the item concerned, and a short
          description of the issue. We will reply with the return eligibility,
          destination, and next steps that apply to your purchase.
        </p>
        <ul className="tablet:text-16 list-disc pl-20 text-16 leading-22 tablet:leading-22 mb-48 font-light tracking-tight text-black">
          <li>Items must be unused and returned with their original packaging.</li>
          <li>Personalized, resized, worn, or damaged items may not be eligible unless faulty.</li>
          <li>Do not mail a return until you have received return instructions.</li>
          <li>Approved refunds are sent to the original payment method.</li>
          <li>Your statutory consumer rights are not affected.</li>
        </ul>
        <p>Contact: <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a></p>
      </div>
    </main>
  );
}

export default Returns;
